import { LISTING_TYPES, getDefaultMintForAssetSymbol } from '../lib/constants';

/**
 * Local catalog fallback shown when Firebase has not been configured yet.
 */
export const mockProducts = [
  {
    id: 'impact-pack-01',
    slug: 'impact-pack-01',
    title: 'Impact Pack 01',
    description: 'Heavy cinematic impacts and trailer hits.',
    productType: 'soundPack',
    listingType: LISTING_TYPES.NATIVE,
    isFree: false,
    isActive: true,
    isHomepageFeatured: true,
    tags: ['cinematic', 'impact'],
    platformTags: ['sfx'],
    stripeConfig: { enabled: true, priceId: 'price_placeholder' },
    solanaConfig: {
      enabled: true,
      recipientWallet: '',
      acceptedAssets: [
        { symbol: 'SOL', mint: null, amount: 0.069, amountAtomic: 69000000 },
        {
          symbol: 'USDC',
          mint: getDefaultMintForAssetSymbol('USDC'),
          amount: 5,
          amountAtomic: 5000000,
        },
      ],
      defaultAsset: 'SOL',
    },
    externalConfig: {
      enabled: false,
      externalPlatform: '',
      externalUrl: '',
      buttonLabel: '',
      embedUrl: '',
      embedType: '',
      embedHtml: '',
    },
  },
  {
    id: 'max4live-legacy-suite',
    slug: 'max4live-legacy-suite',
    title: 'Legacy Max for Live Suite',
    description: 'Legacy instrument bundle fulfilled on Gumroad.',
    productType: 'soundPack',
    listingType: LISTING_TYPES.LEGACY_EXTERNAL,
    isFree: false,
    isActive: true,
    isHomepageFeatured: true,
    tags: ['legacy'],
    platformTags: ['ableton', 'max4live'],
    stripeConfig: { enabled: false, priceId: '' },
    solanaConfig: { enabled: false, recipientWallet: '', acceptedAssets: [], defaultAsset: 'SOL' },
    externalConfig: {
      enabled: true,
      externalPlatform: 'gumroad',
      externalUrl: 'https://gumroad.com',
      buttonLabel: 'Buy on Gumroad',
      embedUrl: '',
      embedType: '',
      embedHtml: '',
    },
  },
  {
    id: 'unity-ambient-biomes',
    slug: 'unity-ambient-biomes',
    title: 'Unity Ambient Biomes',
    description: 'Loop-ready biome ambiences for Unity projects.',
    productType: 'soundPack',
    listingType: LISTING_TYPES.EXTERNAL_MARKETPLACE,
    isFree: false,
    isActive: true,
    isHomepageFeatured: true,
    tags: ['game-audio'],
    platformTags: ['unity'],
    stripeConfig: { enabled: false, priceId: '' },
    solanaConfig: { enabled: false, recipientWallet: '', acceptedAssets: [], defaultAsset: 'SOL' },
    externalConfig: {
      enabled: true,
      externalPlatform: 'unity',
      externalUrl: 'https://assetstore.unity.com',
      buttonLabel: 'View on Unity Asset Store',
      embedUrl: 'https://www.youtube.com/embed/DLzxrzFCyOs',
      embedType: 'youtube',
      embedHtml: '',
    },
  },
  {
    id: 'free-drum-starter',
    slug: 'free-drum-starter',
    title: 'Free Drum Starter',
    description: 'Starter drum one-shots for free download.',
    productType: 'singleSound',
    listingType: LISTING_TYPES.FREE,
    isFree: true,
    isActive: true,
    isHomepageFeatured: true,
    tags: ['drums', 'starter'],
    platformTags: ['sfx'],
    stripeConfig: { enabled: false, priceId: '' },
    solanaConfig: { enabled: false, recipientWallet: '', acceptedAssets: [], defaultAsset: 'SOL' },
    externalConfig: {
      enabled: false,
      externalPlatform: '',
      externalUrl: '',
      buttonLabel: '',
      embedUrl: '',
      embedType: '',
      embedHtml: '',
    },
  },
];
